module.exports = __webpack_public_path__ + "static/media/icon_ds_tk.da9807fd.svg";